import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 w-full z-50 flex justify-around items-center px-8 pb-6 pt-3 bg-[#f9f9f9]/80 backdrop-blur-xl rounded-t-[2rem] shadow-[0px_-10px_40px_rgba(0,106,98,0.06)]">
      {/* Home */}
      <button
        onClick={() => navigate('/')}
        className={`flex flex-col items-center justify-center px-5 py-1.5 rounded-full transition-all duration-300 active:scale-90 ${
          isActive('/') ? 'bg-primary/10 text-primary' : 'text-slate-400 hover:text-primary'
        }`}
      >
        <span className="material-symbols-outlined" style={isActive('/') ? { fontVariationSettings: "'FILL' 1" } : {}}>
          home
        </span>
        <span className="font-label text-[11px] font-semibold tracking-wide mt-0.5">בית</span>
      </button>

      {/* Recipe Book – floating center pill */}
      <button
        onClick={() => navigate('/book')}
        className={`flex flex-col items-center justify-center p-3 rounded-full transition-all duration-300 active:scale-90 shadow-lg -translate-y-2 ${
          isActive('/book')
            ? 'bg-gradient-to-br from-primary to-primary-container text-white shadow-primary/30'
            : 'bg-gradient-to-br from-primary to-primary-container text-white shadow-primary/20'
        }`}
      >
        <span
          className="material-symbols-outlined"
          style={{ fontVariationSettings: isActive('/book') ? "'FILL' 1" : "'FILL' 0" }}
        >
          menu_book
        </span>
      </button>

      {/* Profile */}
      <button
        onClick={() => navigate('/profile')}
        className={`flex flex-col items-center justify-center px-5 py-1.5 rounded-full transition-all duration-300 active:scale-90 ${
          isActive('/profile') ? 'bg-primary/10 text-primary' : 'text-slate-400 hover:text-primary'
        }`}
      >
        <span className="material-symbols-outlined" style={isActive('/profile') ? { fontVariationSettings: "'FILL' 1" } : {}}>
          person
        </span>
        <span className="font-label text-[11px] font-semibold tracking-wide mt-0.5">פרופיל</span>
      </button>
    </nav>
  );
};

export default Navbar;